import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class UserListConverter implements JsonCustomConvert<UserList> {
  serialize() {}

  deserialize(data: any): UserList {
    const jsonConvert = new JsonConvert();
    return jsonConvert.deserializeObject(data, UserList);
  }
}

@JsonConverter
export class UserListArrayConverter implements JsonCustomConvert<Array<UserList>> {
  serialize() {}

  deserialize(data: any): Array<UserList> {
    const jsonConvert = new JsonConvert();
    const items = Array.isArray(data) ? data : [];
    return items.map((item) => jsonConvert.deserializeObject(item, UserList));
  }
}

@JsonConverter
export class UserCountListConverter implements JsonCustomConvert<UserCountList> {
  serialize() {}

  deserialize(data: any): UserCountList {
    const result = new UserCountList();
    result.count = typeof data?.count === "number" ? data.count : 0;
    const items = Array.isArray(data?.items) ? data.items : Array.isArray(data?.data) ? data.data : [];
    result.items = new UserListArrayConverter().deserialize(items);
    return result;
  }
}

@JsonObject("UserList")
export class UserList {
  @JsonProperty("userId", String, true)
  userId: string = "";

  @JsonProperty("name", String, true)
  name: string = "";

  @JsonProperty("lastName", String, true)
  lastName: string = "";

  @JsonProperty("email", String, true)
  email: string = "";

  @JsonProperty("companyName", String, true)
  companyName: string = "";

  @JsonProperty("piva", String, true)
  piva: string = "";

  @JsonProperty("street", String, true)
  street: string = "";

  @JsonProperty("city", String, true)
  city: string = "";

  @JsonProperty("zip", String, true)
  zip: string = "";

  @JsonProperty("province", String, true)
  province: string = "";

  @JsonProperty("state", String, true)
  state: string = "";

  @JsonProperty("userKey", String, true)
  userKey: string = "";

  @JsonProperty("licenseId", String, true)
  licenseId: string = "";

  @JsonProperty("enabled", Boolean, true)
  enabled: boolean = false;

  toCreatePayload() {
    return {
      name: this.name,
      lastName: this.lastName,
      email: this.email,
      companyName: this.companyName,
      piva: this.piva,
      street: this.street,
      city: this.city,
      zip: this.zip,
      province: this.province,
      state: this.state,
      userKey: this.userKey,
      enabled: this.enabled,
    };
  }

  toUpdatePayload() {
    return {
      name: this.name,
      lastName: this.lastName,
      companyName: this.companyName,
      piva: this.piva,
      street: this.street,
      city: this.city,
      zip: this.zip,
      province: this.province,
      state: this.state,
      userKey: this.userKey,
      enabled: this.enabled,
    };
  }
}

@JsonObject("UserCountList")
export class UserCountList {
  @JsonProperty("count", Number, true)
  count: number = 0;

  @JsonProperty("items", UserListArrayConverter, true)
  items: Array<UserList> = [];
}

@JsonObject("UserListData")
export class UserListData extends BaseResponse {
  @JsonProperty("data", UserListConverter, true)
  data: UserList = new UserList();
}

@JsonObject("UserListDataArray")
export class UserListDataArray extends BaseResponse {
  @JsonProperty("data", UserCountListConverter, true)
  data: UserCountList = new UserCountList();
}
